import {
  Heading,
  HStack,
  InfoCard,
  Text,
  VStack,
} from '@ayble-health/dashboard-components';
import styled from '@emotion/styled';
import type { EmotionTheme } from '../../theme/emotionTheme';

const MANUAL_LINK =
  'https://docs.google.com/document/d/1tUsrTOIUGst3-bT853VKqJNPXUH9Heuw4vponE9qFoU/edit?tab=t.0#heading=h.amktyjgwj95c';
const TECH_SUPPORT_LINK =
  'https://docs.google.com/forms/d/e/1FAIpQLSd306lYbkmmqvPvW5gA-wjBrRP9mnldZbewELT9CQcQ4uLM2g/viewform?usp=dialog';
const PATIENT_PULSE_LINK =
  'https://docs.google.com/forms/d/e/1FAIpQLSfS_1PqzWrDmQtBCjDPByIAaEtKXrxLEqQUsJ7p6vKZrlyJrw/viewform';

const GradientBox = styled('div')<{ theme?: EmotionTheme }>`
  align-items: center;
  background-image: linear-gradient(to bottom, #ffffff, #ebf5ff, #ebf5ff);
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const SupportPage = () => {
  return (
    <GradientBox>
      <HStack
        alignItems="flex-start"
        justifyContent="center"
        minH={{ base: '95%', lg: '80%' }}
      >
        <VStack alignItems={'flex-end'} flex={1} px={4} py={8} minW={'270px'}>
          <Heading fontSize={'3xl'} fontWeight={'normal'}>How can we help?</Heading>
        </VStack>

        <VStack flex={3} p={8} maxW={'800'} w={'100%'} h={'100%'}>
          <HStack flex={1} pb={4} minW={'500px'}>
            <InfoCard
              borderTopRadius={'md'}
              borderBottomRadius={'xl'}
              content={
                <Text
                  color={'blueGray.600'}
                  fontSize={{ base: 'md', xl: 'lg' }}
                >
                  This is your first line of defense! Most questions about{' '}
                  <Text fontWeight={'bold'}>
                    how to use Ayble’s care team platform
                  </Text>{' '}
                  can be answered here.
                </Text>
              }
              emoji={'📕'}
              onPrimaryButtonClick={() => {
                window.open(MANUAL_LINK, '_blank')?.focus();
              }}
              primaryButtonText={'See FAQs'}
              title={'Ayble Care Team Manual'}
            />
          </HStack>

          <HStack flex={1} pt={4} minW={'500px'}>
            <HStack flex={1} pr={4}>
              <InfoCard
                borderTopRadius={'md'}
                borderBottomRadius={'xl'}
                content={
                  <Text
                    color={'blueGray.600'}
                    fontSize={{ base: 'md', '2xl': 'lg' }}
                  >
                    Submit all{' '}
                    <Text fontWeight={'bold'}>
                      tech issues, bugs, or customer support questions
                    </Text>
                    that need attention here! We’ll get back to you as quickly
                    as possible.
                  </Text>
                }
                emoji={'🤖'}
                onPrimaryButtonClick={() => {
                  window.open(TECH_SUPPORT_LINK, '_blank')?.focus();
                }}
                primaryButtonText={'Submit Support Ticket'}
                stretchButtons
                title={'Tech Support'}
              />
            </HStack>

            <HStack flex={1} pl={4}>
              <InfoCard
                borderTopRadius={'md'}
                borderBottomRadius={'xl'}
                content={
                  <Text
                    color={'blueGray.600'}
                    fontSize={{ base: 'md', '2xl': 'lg' }}
                  >
                    Share insights that help us create a better product!{' '}
                    <Text fontWeight={'bold'}>
                      Celebrate patient wins or frustrations
                    </Text>
                    , and <Text fontWeight={'bold'}>submit feature ideas.</Text>
                  </Text>
                }
                emoji={'💡'}
                onPrimaryButtonClick={() => {
                  window.open(PATIENT_PULSE_LINK, '_blank')?.focus();
                }}
                primaryButtonText={'Submit Wins & Ideas'}
                stretchButtons
                title={'Patient Pulse'}
              />
            </HStack>
          </HStack>
        </VStack>
      </HStack>
    </GradientBox>
  );
};
